var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#005FF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.53 11.22a.75.75 0 010 1.06l-9.5 9.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.97 3.97 8.97-8.97a.75.75 0 011.06 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjAuNSIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iMTYiIGZpbGw9IiMwMDVGRjkiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQuNTMwMyAxMS4yMTk3QzI0LjgyMzIgMTEuNTEyNiAyNC44MjMyIDExLjk4NzQgMjQuNTMwMyAxMi4yODAzTDE1LjAzMDMgMjEuNzgwM0MxNC43Mzc0IDIyLjA3MzIgMTQuMjYyNiAyMi4wNzMyIDEzLjk2OTcgMjEuNzgwM0w5LjQ2OTY3IDE3LjI4MDNDOS4xNzY3OCAxNi45ODc0IDkuMTc2NzggMTYuNTEyNiA5LjQ2OTY3IDE2LjIxOTdDOS43NjI1NiAxNS45MjY4IDEwLjIzNzQgMTUuOTI2OCAxMC41MzAzIDE2LjIxOTdMMTQuNSAyMC4xODkzTDIzLjQ2OTcgMTEuMjE5N0MyMy43NjI2IDEwLjkyNjggMjQuMjM3NCAxMC45MjY4IDI0LjUzMDMgMTEuMjE5N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgConnectOk as ReactComponent };